// extracted by mini-css-extract-plugin
export default {"title":"each-item_title__MrEHT","itemEditButton":"each-item_itemEditButton__Il3ZC"};